import React from "react";
import "./style.css";
import arrowIcon from "../../assets/up-right-arrow-white.svg";
import bottleNeck from "../../assets/media/bottleneck.png";
const BottleNecks = () => {
  return (
    <div className=" bottle-container d-flex justify-content-between align-items-center w-100 ">
      <div className="section-container w-100" style={{ margin: "auto" }}>
        {" "}
        <div className="page-container  w-100 d-flex justify-content-between">
          <div className="d-flex content flex-column">
            <div
              className="title"
              style={{
                fontSize: "3.5rem",
                fontWeight: 700,
                lineHeight: "4rem",
              }}
            >
              Ready to Remove <br />
              <span>the Bottlenecks</span>?
            </div>
            <div className="info-text">
              See How Fast, Accurate, and Stress-free Your Next Launch Can Be—
              with Two Platforms Built to Scale with You.
            </div>
            <div className="book">
              Book a 15‑minute demo and see how fast compliance can be.
            </div>
            <button
              className="btn btn-primary book-demo-btn"
              onClick={() =>
                window.open(
                  "https://connect.regulatecpg.com/regulate-book-a-demo",
                  "_blank"
                )
              }
            >
              Book Demo
              <div className="btn-icon-container">
                {" "}
                <img
                  src={arrowIcon}
                  alt=""
                  style={{ height: "0.9rem", width: "0.9rem" }}
                />
              </div>
            </button>
          </div>
          <img src={bottleNeck} alt="" className="bottle-neck" />
        </div>{" "}
      </div>
    </div>
  );
};

export default BottleNecks;
